// extracted by mini-css-extract-plugin
export var fadeInOut = "_17-3";
export var icon = "_17-4";
export var savedIndicator = "_17-2";
export var savingIndicator = "_17-0";
export var spin = "_17-1";